import api from "../index";
// import * as _helper from '../helper';
import * as URL from "../url";

export const RestartServer = async () => {
  try {
    const response = await api.get("/restart");
    console.log("response restart** ", response);
    return response;
  } catch (error) {
    // _helper.sendResponse('error', error.message)
    console.log(error, "<<");
    return;
  }
};

export const ProfileList = async (params = {}) => {
  try {
    const response = await api.get(URL.ROLE, { params });
    console.log("response RoleLists** ", response);
    return response;
  } catch (error) {
    // _helper.sendResponse('error', error.message)
    console.log(error, "<<");
    return;
  }
};

export const CreateProfile = async (body) => {
  try {
    const response = await api.post(URL.ROLE, body);
    console.log("response CreateRole** ", response);
    return response;
  } catch (error) {
    console.log(error, "<<");
    return;
  }
};

export const EnableById = async (id) => {
  try {
    const response = await api.patch(URL.ROLEENABLE + id);
    console.log("response EnableById** ", response);
    return response;
  } catch (error) {
    // _helper.sendResponse('error', error.message)
    console.log(error, "<<");
    return;
  }
};

export const DisableById = async (id) => {
  try {
    const response = await api.patch(URL.ROLEDISABLE + id);
    console.log("response DisableById** ", response);
    return response;
  } catch (error) {
    // _helper.sendResponse('error', error.message)
    console.log(error, "<<");
    return;
  }
};

export const DeleteById = async (id) => {
  try {
    const response = await api.patch(URL.ROLEDELETE + id);
    console.log("response DeleteById** ", response);
    return response;
  } catch (error) {
    // _helper.sendResponse('error', error.message)
    console.log(error, "<<");
    return;
  }
};
